import { breadcrumbJsonLd } from "@/content/schema";
import { OG_IMAGE, ORG_ID, abs } from "@/content/siteConfig";
import type { LocalPage } from "@/content/localPages";
import { LOCAL_FAQS, faqJsonLd } from "@/content/faqs";

export function localPageHead(page: LocalPage, parent?: { name: string; path: string }) {
  const url = abs(page.path);
  const crumbs = [{ name: "Home", path: "/" }, ...(parent ? [parent] : []), { name: page.breadcrumb, path: page.path }];
  return {
    meta: [
      { title: page.title },
      { name: "description", content: page.description },
      { property: "og:title", content: page.title },
      { property: "og:description", content: page.description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: url },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: page.title },
      { name: "twitter:description", content: page.description },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: url }],
    scripts: [
      { type: "application/ld+json", children: breadcrumbJsonLd(crumbs) },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          name: page.breadcrumb,
          description: page.description,
          url,
          provider: { "@id": ORG_ID },
          ...(page.city ? { areaServed: { "@type": "City", name: `${page.city}, Arizona` } } : page.region ? { areaServed: { "@type": "State", name: page.region } } : {}),
        }),
      },
      ...(LOCAL_FAQS[page.path] ? [{ type: "application/ld+json", children: faqJsonLd(LOCAL_FAQS[page.path]!) }] : []),
    ],
  };
}
